import React from "react";

// Minimal line-art African motif icons for category cards.
// Each accepts a className for size/color inheritance (uses currentColor).

export function DrumIcon({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {/* Drum head */}
      <ellipse cx="16" cy="7" rx="8" ry="2.4" />
      {/* Body silhouette (goblet) */}
      <path d="M8 7 L11 18 Q12 21 12 24 L12 28 Q12 29 13 29 L19 29 Q20 29 20 28 L20 24 Q20 21 21 18 L24 7" />
      {/* Tension ropes */}
      <path d="M9.2 8.5 L11.5 15" />
      <path d="M13 8.9 L14 16" />
      <path d="M19 8.9 L18 16" />
      <path d="M22.8 8.5 L20.5 15" />
      {/* Waist accent */}
      <path d="M11 24 Q16 22 21 24" />
    </svg>
  );
}

export function HutIcon({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {/* Thatched conical roof */}
      <path d="M4 15 L16 3 L28 15 Z" />
      {/* Roof thatch lines */}
      <path d="M9 15 L13 5" />
      <path d="M16 3 L16 15" />
      <path d="M23 15 L19 5" />
      {/* Wall */}
      <path d="M7 15 L7 26 L25 26 L25 15" />
      {/* Door */}
      <path d="M13 26 L13 20 Q13 18 16 18 Q19 18 19 20 L19 26" />
      {/* Small window bricks */}
      <circle cx="10.5" cy="20" r="0.6" fill="currentColor" />
      <circle cx="22" cy="20" r="0.6" fill="currentColor" />
    </svg>
  );
}

export function BaobabIcon({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {/* Ground line */}
      <path d="M4 27 L28 27" />
      {/* Wide iconic trunk */}
      <path d="M11 27 L11 15 Q11 12 13 11 L13 9" />
      <path d="M21 27 L21 15 Q21 12 19 11 L19 9" />
      <path d="M13 12 L19 12" />
      {/* Bare branch crown (upside-down roots feel) */}
      <path d="M13 9 Q12 6 9 5" />
      <path d="M13 9 Q11 7 8 8" />
      <path d="M16 9 L16 4" />
      <path d="M16 5 Q18 5 20 3" />
      <path d="M19 9 Q20 6 23 5" />
      <path d="M19 9 Q21 7 24 8" />
      {/* Small leaf clusters */}
      <circle cx="9" cy="5" r="0.9" fill="currentColor" />
      <circle cx="16" cy="4" r="0.9" fill="currentColor" />
      <circle cx="23" cy="5" r="0.9" fill="currentColor" />
    </svg>
  );
}
